import { IconType } from "../icon-props";

const Download: IconType = (
        <>
            <path fillRule="evenodd" clipRule="evenodd" d="M11.0032 9.672L14.9532 5.722L16.3672 7.136L10.0032 13.5L3.63919 7.136L5.05319 5.722L9.00319 9.672V0L11.0032 2.38419e-07V9.672ZM2 17H18V10H20V18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H1C0.734784 19 0.48043 18.8946 0.292893 18.7071C0.105357 18.5196 0 18.2652 0 18V10H2V17Z"/>
        </>
    );

export default Download;